(() => {
  if (customElements.get('ls-bundle-guide')) return;
  customElements.define('ls-bundle-guide', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.message = this.querySelector('[data-bundle-message]');
      this.complete = this.querySelector('[data-complete-bundle]');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked', 'data-value'] });
      this.onComplete = () => this.chooseNext();
      this.complete.addEventListener('click', this.onComplete);
      this.onPurchase = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const button = target.closest('button[name="add"]');
        const form = target.closest('form[data-type="add-to-cart-form"]');
        if ((event.type === 'click' && !button) || (event.type === 'submit' && !form)) return;
        const state = this.state();
        if (!state?.remaining) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.update();
        this.chooseNext();
      };
      this.root.addEventListener('click', this.onPurchase, true);
      this.root.addEventListener('submit', this.onPurchase, true);
      this.update();
    }
    state() {
      const widget = this.root.querySelector('kaching-bundles-block');
      const selected = widget?.querySelector('.kaching-bundles__bar--selected');
      if (!selected) return null;
      let config;
      try { config = JSON.parse(widget.getAttribute('deal-block')); } catch { return null; }
      const deal = config.dealBars?.find(bar => bar.id === selected.dataset.dealBarId);
      if (!deal) return null;
      const total = Number(deal.quantity || (Number(deal.buyQuantity) + Number(deal.getQuantity)));
      const choices = [...selected.querySelectorAll('.kaching-bundles__collection-product__choose-product-button')];
      return { widget, selected, total, remaining: choices.length, choices, gifts: (deal.freeGifts || []).length > 0 };
    }
    update() {
      const state = this.state();
      this.hidden = !state;
      if (!state) return;
      if (!state.widget.id) state.widget.id = 'ls-bundle';
      const pattern = state.remaining ? this.dataset.progress : state.gifts ? this.dataset.ready : this.dataset.single;
      const text = pattern.replace('{remaining}', state.remaining).replace('{total}', state.total);
      if (this.message.textContent !== text) this.message.textContent = text;
      this.complete.hidden = state.remaining === 0;
      if (!this.boundWidget || this.boundWidget !== state.widget) {
        this.boundWidget = state.widget;
        ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(name => state.widget.addEventListener(name, this.schedule));
      }
      if (location.hash === '#ls-bundle' && !this.didJump) {
        this.didJump = true;
        state.widget.scrollIntoView({ block: 'start' });
      }
    }
    chooseNext() {
      const state = this.state();
      const next = state?.choices[0];
      if (!next) return;
      next.scrollIntoView({ block: 'center', behavior: 'smooth' });
      next.focus({ preventScroll: true });
      next.click();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('click', this.onPurchase, true);
      this.root?.removeEventListener('submit', this.onPurchase, true);
      this.complete?.removeEventListener('click', this.onComplete);
      if (this.boundWidget) ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(name => this.boundWidget.removeEventListener(name, this.schedule));
    }
  });
})();
